import { AttentionBlock, CopyField, toast } from '@westhetics/ui'
import { curlTest } from './labels'

/**
 * A chave do app, mostrada uma única vez (RN-INT-02): ao criar e ao regenerar. Depois disso a tela mostra só o
 * prefixo. Quando a API repetiu a resposta guardada (a mesma criação de novo), a chave vem nula e a saída é
 * regenerar.
 */
export function IntegrationKey({
  appKey,
  previousKeyValidUntil,
}: {
  /** `null` quando a resposta repetida veio sem a chave. */
  appKey: string | null
  /** Na regeneração: até quando a anterior ainda vale. */
  previousKeyValidUntil?: string | null
}) {
  if (!appKey) {
    return (
      <AttentionBlock title="A chave já foi mostrada">
        Ela aparece uma única vez. Se não copiou, regenere a chave na página do app: a anterior
        deixa de valer em 15 minutos.
      </AttentionBlock>
    )
  }
  return (
    <AttentionBlock title="Copie a chave agora" aria-label="Chave do app">
      <p>
        Esta chave não aparece de novo. Guarde num cofre de senhas ou na configuração do sistema que
        vai usá-la. Se perder, regenere.
        {previousKeyValidUntil
          ? ` A chave anterior continua aceita até ${new Date(previousKeyValidUntil).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}, para a troca sem queda.`
          : ''}
      </p>
      <CopyField
        className="mt-4"
        label="Chave do app"
        value={appKey}
        emphasis
        copyAriaLabel="Copiar a chave do app"
        onCopied={() => toast('Chave copiada')}
      />
      <CopyField
        className="mt-4"
        multiline
        label="Teste a chave"
        value={curlTest(appKey)}
        copyLabel="Copiar comando"
        copyAriaLabel="Copiar o comando de teste"
        note="Responde o app, a clínica e as permissões. Erro 401 é chave copiada pela metade."
      />
    </AttentionBlock>
  )
}
